export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "r-v3/js/ImageUtilsWorker.runner.6f4db0e2.worker.js");
}
